import React from 'react';
import { SavedFile } from '../../types/saved-file.type';
import { FileUploadItem } from '../file-upload-item/FileUploadItem';
import './filesUploadList.css';

export const FilesUploadList = ({ files, handleRemove, handleView }: FilesListProps) => {
  return (
    <div className={'files-list'}>
      {files.map((file, index) => (
        <div key={`${file.name}-${index}`}>
          <FileUploadItem file={file} handleView={() => handleView(index)} handleRemove={() => handleRemove(index)} />
        </div>
      ))}
    </div>
  );
};

interface FilesListProps {
  files: SavedFile[];
  handleView: (index: number) => void;
  handleRemove: (index: number) => void;
}